/**
 * 모바일 브라우저(특히 iOS Safari) 및 PWA에서 좌/우 가장자리 스와이프로
 * 발생하는 뒤로/앞으로 가기 제스처를 전역 차단.
 *
 * 1) CSS `overscroll-behavior-x: none`은 Chrome/Android에서 동작하지만
 *    iOS Safari의 가장자리 스와이프는 차단하지 못함.
 * 2) iOS Safari는 화면 좌/우 가장자리에서 시작한 horizontal touch를
 *    네이티브 제스처로 가로채 history navigation을 트리거. touchstart가
 *    가장자리에서 시작했다면 첫 touchmove를 preventDefault 하여 차단.
 *
 * 게임 내부 드래그/탭은 가장자리 한정(EDGE_PX) 검사이므로 영향 없음.
 */

const EDGE_PX = 20;

let installed = false;
let startX: number | null = null;
let startY: number | null = null;
let nearEdge = false;

function onTouchStart(e: TouchEvent): void {
  if (e.touches.length !== 1) {
    nearEdge = false;
    return;
  }
  const t = e.touches[0];
  if (!t) return;
  startX = t.clientX;
  startY = t.clientY;
  const w = window.innerWidth;
  nearEdge = startX <= EDGE_PX || startX >= w - EDGE_PX;
}

function onTouchMove(e: TouchEvent): void {
  if (!nearEdge || startX === null || startY === null) return;
  const t = e.touches[0];
  if (!t) return;
  const dx = t.clientX - startX;
  const dy = t.clientY - startY;
  if (Math.abs(dx) > Math.abs(dy) && e.cancelable) {
    e.preventDefault();
  }
}

function onTouchEnd(): void {
  startX = null;
  startY = null;
  nearEdge = false;
}

export function initSwipeNavGuard(): void {
  if (installed) return;
  installed = true;
  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchmove', onTouchMove, { passive: false });
  document.addEventListener('touchend', onTouchEnd, { passive: true });
  document.addEventListener('touchcancel', onTouchEnd, { passive: true });
}
